import "./MarketingCopy.css";

const BULLETS = [
  "Hundreds of retro (and new) TV shows",
  "Ad-free streaming",
  "Watch on any device",
  "Cancel anytime",
];

export function MarketingCopy() {
  return (
    <section className="marketing-copy" aria-labelledby="value-prop">
      <p className="marketing-copy__lead">
        <span>Classic shows. Iconic moments.</span>
        <span>All in one place.</span>
      </p>
      <p className="marketing-copy__emphasis" id="value-prop">
        Stream timeless TV from the past (and present) with no ads, high
        quality, and new favorites added weekly.
      </p>
      <ul className="marketing-copy__bullets">
        {BULLETS.map((item) => (
          <li key={item} className="marketing-copy__bullet">
            <span className="marketing-copy__marker" aria-hidden="true" />
            <span className="marketing-copy__bullet-text">{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
